

console.log("firebase", firebase);
const auth = firebase.auth()
const db = firebase.firestore();
// invisible recaptcha
window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('registerButton', {
  'size': 'invisible',
  'callback': (response) => {
    // reCAPTCHA solved, allow signInWithPhoneNumber.
    console.log("response", response);
    // window.recaptchaWidgetId = response;
    // onSignInSubmit();
  }
});
// const messaging = firebase.messaging();
const messaging = firebase.messaging.isSupported() ? firebase.messaging() : null
if (messaging) {

  function subscribeTokenToTopic(token, topic) {
    fetch(`https://iid.googleapis.com/iid/v1/${token}/rel/topics/${topic}`, {
      method: 'POST',
      headers: new Headers({
        // Authorization: `key=${FCM_SERVER_KEY}`
        Authorization: `key=AAAAOat5kLI:APA91bGaBVsWOzrvFF8CItuq_BmLwfO6B8OU6UoPI2uEpsH5_NMob1WQfC07dpfp9sqHfk-wY5Gdw9cKCOzic8FvQhnPyGcxVsgcGE5d_fjbGFSyIZDG5FY_WAu7h7hMBlAflKhAya5S`
      })
    })
      .then((response) => {
        if (response.status < 200 || response.status >= 400) {
          console.log(response.status, response);
        }
        console.log(`"${topic}" is subscribed`);
      })
      .catch((error) => {
        console.error(error.result);
      });
    return true;
  }


  messaging.getToken({ vapidKey: 'BMvZ3SuRg1hWQHELgfZzlfKIF-IcZxnt9ICWrtJq84IMvjUvGYtQSpDAKk7Mf1Jy93_vSnaaSIz0zztOX_ZXG6s' }).then((currentToken) => {
    if (currentToken) {
      console.log('currentToken', currentToken);
      subscribeTokenToTopic(currentToken, "allDevice")

    } else {
      // Show permission request.
      console.log('No registration token available. Request permission to generate one.');
      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          console.log('Notification permission granted.');
          MsgElem.innerHTML = "Notification permission granted."
          // TODO(developer): Retrieve a registration token for use with FCM.
          // In many cases once an app has been granted notification permission,
          // it should update its UI reflecting this.
        } else {
          console.log('Unable to get permission to notify.');
        }
      });
    }
  }).catch((err) => {
    console.log('An error occurred while retrieving token. ', err);
    // alert("Notifications bloquées. Veuillez les activer dans votre navigateur.");
  });

}


// messaging.onMessage((payload) => {
//   console.log('Message received. ', payload);
//   // ...
// });


function monthDiff(d1, d2) {
  if (!d1) {
    return 1
  }
  var months;
  console.log("d1", d1);
  console.log("d2", d2);
  months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months -= d1.getMonth();
  months += d2.getMonth();
  return months <= 0 ? 0 : months;
}


function playAndSaveDate(data, formData) {
  // console.log("spin", spin());
  let prize = spin().value;
  db.collection("users").doc(data.user.uid).set({
    ...formData, prize,
    // when we send new Date() to firebase it will be saved defaultly as Timtestamp firebase
    updatedAt: new Date()
  }).then(function (docRef) {
    // send mail to the winner
    sendMailToTheWinner(formData, prize, data.user.uid)
    console.log("Document written: ", docRef);
  }).catch(function (error) {
    console.error("Error adding document: ", error);
    if (window.confirm("Vos coordonnées n'ont pas été sauvegardées, veuillez réessayer avec un autre numéro de téléphone.")) {
      document.location.reload();
    }
  });
}

console.log("new Date", new Date());
// setTimeout(() => {
//   window.togglePause(false)
//   const fireContainer = document.getElementById('fire-container-id')
//   fireContainer.style.zIndex=9999
// }, 3000);


const spinner = document.getElementById('spinner')
const smsCodeInput = document.getElementById('smsCode')
const smsCodeField = document.getElementById('smsCodeField')
const fullNameField = document.getElementById('fullNameField')
const emailField = document.getElementById('emailField')
const phoneField = document.getElementById('phoneField')
const ageField = document.getElementById('ageField')
const sexField = document.getElementById('sexField')
const registerButton = document.getElementById('registerButton')
const phoneNumberField = document.getElementById('phoneField')

const phoneInput = document.getElementById('phone')

function phoneFocusOrBLur(e) {
  console.log("eon focus", e.target.value);
  console.log("phoneField focus", phoneField);
  if (!e.target.value.startsWith("+216")) {
    phoneInput.value = "+216" + phoneInput.value
  }
}

phoneInput.onfocus = phoneFocusOrBLur
phoneInput.onblur = phoneFocusOrBLur

phoneInput.onkeypress = phoneKeyPress
// accept only numbers
function phoneKeyPress(e) {
  //  realtime tapped character =>  e.key
  console.log("aaaaaaaaaaaaaaa", e.key);
  var pattern3 = '^\\d*$'
  var validNumber = new RegExp(pattern3);
  // console.log("validNumber", res, validNumber.test(e.target.value))
  console.log("oninput validNumber", validNumber.test(e.key));
  if (!validNumber.test(e.key)) {
    e.preventDefault();
  }
}

// block  user ???
// patter start with 216 ?



window.register = function (e) {

  spinner.style.display = "inline-block"
  // prevent form form navigation
  e.preventDefault();

  var target = e.target || e.srcElement;
  // // Set Form Values to Variables
  // var name = target.elements["name"].value;
  // var message = target.elements["message"].value;


  console.log("window.getComputedStyle(smsCodeField).display", window.getComputedStyle(smsCodeField).display);

  //  ************* send confirmation code
  if (window.getComputedStyle(smsCodeField).display === "none") {
    const appVerifier = window.recaptchaVerifier;
    // Sends the 6 digit code to the user's phone
    auth.signInWithPhoneNumber(target.elements["phone"].value, appVerifier)
      .then(confirmationResult => {
        // SMS sent. Prompt user to type the code from the message, then sign the
        // user in with confirmationResult.confirm(code).
        const sentCodeId = confirmationResult.verificationId;
        window.sentCodeId = sentCodeId;
        smsCodeField.style.display = "inline-block"
        fullNameField.style.display = "none"
        emailField.style.display = "none"
        ageField.style.display = "none"
        phoneField.style.display = "none"
        sexField.style.display = "none"

        spinner.style.display = "none";
        registerButton.innerHTML = "Vérifier le code"
        // Sign in if the verification code is set correctly
        console.log("target.elements", target.elements);
        console.log("male", target.elements["male"]);
        console.log("male", target.elements["male"].checked);
        console.log("female ", target.elements["female "]);
        let sex = target.elements["male"].checked ? "male" : undefined
        if (sex === undefined && target.elements["female"].checked) {
          sex = "female"
        }
        registerButton.addEventListener('click', () => signInWithPhone(sentCodeId, {
          phone: target.elements["phone"] ? target.elements["phone"].value : undefined,
          fullName: target.elements["fullName"] ? target.elements["fullName"].value : undefined,
          age: target.elements["age"] ? Number(target.elements["age"].value) : undefined,
          email: target.elements["email"] ? target.elements["email"].value : undefined,
          sex: sex ? sex : "female",
        }));
      }).catch((error) => {
        // Error; SMS not sent
        // ...
        console.log("catch", error);
        spinner.style.display = "none";
        // invalid phone error
        if (error.code === "auth/invalid-phone-number") {
          if (window.confirm("Numéro de téléphone invalide!")) {
            document.location.reload();
          }
        }
        // othercase
        else {
          if (window.confirm("un probleme est survenu lors de la connexion au serveur, veuillez réessayer svp")) {
            document.location.reload();
          }
        }
      })
  }


};


// ************* verify confirmation code and register then create user data row
const signInWithPhone = (sentCodeId, formData) => {
  console.log("formData", formData);
  const code = smsCodeInput.value;
  // A credential object (contains user's data) is created after a comparison between the 6 digit code sent to the user's phone
  // and the code typed by the user in the code field on the html form.

  let credential
  try {
    credential = firebase.auth.PhoneAuthProvider.credential(sentCodeId, code);
  } catch (error) {
    console.log("error is =>", error);
    if (error.code === "auth/missing-verification-code") {
      alert("Veuillez saisir le code reçu par sms")
    }

  }
  auth.signInWithCredential(credential)
    .then((data) => {
      console.log('Signed in successfully data !', data);
      console.log('Signed in successfully !', data.user.uid);
      //  => data.additionalUserInfo.isNewUser will provide if this phone is new or not
      if (data.additionalUserInfo && data.additionalUserInfo.isNewUser && data.user && data.user.uid) {
        playAndSaveDate(data, formData)
      }
      else {
        // popup Vous avez déja jouer en utilisant ce Numéro de téléphone déja utiliser 
        //  Vous pouvez récupére votre cadeau ( ) dans la boutique 
        var docRef = db.collection("users").doc(data.user.uid);
        docRef.get().then((doc) => {
          if (doc.exists) {
            console.log("Document user data:", doc.data());

            if (doc.data().updatedAt) {
              console.log("convert timestamp to date", doc.data().updatedAt.toDate());
              // when we send new Date() to firebase it will be saved defaultly as Timtestamp firebase
              console.log("monthDiff", monthDiff(doc.data().updatedAt.toDate(), new Date()));
            }

            // if there is month difference play and update data 
            // || !doc.data().updatedAt refer to old document without updatedAt
            if ((doc.data().updatedAt && monthDiff(doc.data().updatedAt.toDate(), new Date()))
              || !doc.data().updatedAt) {
              playAndSaveDate(data, formData)
            }
            // show the message
            else {
              if (screen.width > 899) {
                document.getElementById('number').style.width = "45%"
              }
              document.getElementById('winTextId').innerText
                = "Vous pouvez jouer une seule fois par mois, Veuillez récupérer votre bon de réduction de " + String(doc.data().prize) + " dinars dans la boutique."
              document.getElementById('book__form__id').style.display = "none"
            }


          } else {
            // doc.data() will be undefined in this case
            console.log("No such document! => playAndSaveDate call  ");
            playAndSaveDate(data, formData)
          }
        }).catch((error) => {
          console.log("Error getting document:", error);
          if (window.confirm("Erreur lors de récupérations de vos coordonnées! veuillez réessayer avec un autre numéro de téléphone.")) {
            document.location.reload();
          }

        });

      }



    })
    .catch(error => {
      if (error.code === "auth/invalid-verification-code") {
        alert("Code sms invalide")
      }
    })
}


var padding = {
  top: 20,
  right: 20,
  bottom: 0,
  left: 0
},
  w = window.innerWidth > 900 ? 550 : 200 - padding.left - padding.right,
  h = window.innerWidth > 900 ? 550 : 200 - padding.top - padding.bottom,
  //   rayon
  r = Math.min(w, h) / 2,
  roatation = 0,
  oldrotation = 0,
  picked = 100000,
  // filtredDataIndex = [8, 9],
  // remove filtred prize 50 && 100
  filtredDataIndex = [1, 7]
color = d3.scale.category20();

var data = [
  // { label: "Perdu 😭", value: 0, number: "Vous avez perdu!", color: "bleuCiel" },
  // { label: "30 💰💸", value: 30, number: "Géniale, vous avez gagné un bon de réduction de 30 dinars.-", color: "bleuCiel" },
  { label: "10  💰", value: 10, number: "Bravo, vous avez gagné un bon de réduction de 10 dinars sur une de commande de 50 dinars.", color: "orange" },
  { label: "50  💎", value: 50, number: "Wow, vous avez gagné un bon de réduction de 50 dinars sur une commande de 250 dinars.", color: "redd" },
  { label: "10  💰", value: 10, number: "Bravo, vous avez gagné un bon de réduction de 10 dinars sur une commande de 50 dinnars.", color: "pink" },
  { label: "20  💸", value: 20, number: "Géniale, vous avez gagné un bon de réduction de 20 dinars sur une commande de 100 dinars.", color: "yellow" },
  // { label: "40 💸💸", value: 40, number: "Géniale, vous avez gagné un bon de réduction de 40 dinars.-", color: "bleuCiel" },
  // { label: "Perdu 😭", value: 0, number: "Vous avez perdu!", color: "bleuCiel" },
  { label: "10  💰", value: 10, number: "Bravo, vous avez gagné un bon de réduction de 10 dinars sur une commande 50 dinars.", color: "blue" },
  { label: "30 💰💸", value: 30, number: "Oh, vous avez gagné un bon de réduction de 30 dinars sur une commande de 150 dinars.", color: "red" },
  { label: "20  💸", value: 20, number: "Géniale, vous avez gagné un bon de réduction de 20 dinars sur une commande 100 dinars.", color: "green" },
  { label: "100 💎💎", value: 100, number: "Jackpot! vous avez gagné un bon de réduction de 100 dinars sur une commande de 500 dinars.", color: "manyColors" }
];
var svg = d3
  .select("#chart")
  .append("svg")
  .data([data])
  .attr("width", w + padding.left + padding.right)
  .attr("height", h + padding.top + padding.bottom);
var container = svg
  .append("g")
  .attr("class", "chartholder")
  .attr(
    "transform",
    "translate(" + (w / 2 + padding.left) + "," + (h / 2 + padding.top) + ")"
  );
var vis = container.append("g");
var pie = d3.layout
  .pie()
  .sort(null)
  .value(function (d) {
    return 1;
  });

var arc = d3.svg.arc().outerRadius(r);

// create the arcs element with slice class
var arcs = vis
  .selectAll("g.slice")
  .data(pie)
  .enter()
  .append("g")
  .attr("class", "slice");
//   add fill="#2ca02c" and arc angle d="M111.6791979355699,153.71322893124002A190,190 0 0,1 1.1634144591899855e-14,190L0,0Z"
arcs
  .append("path")
  .attr("fill", function (d, i) {
    // return color(i);
    return data[i].color ? `url(#${data[i].color})` : color(i)
  })
  .attr("stroke", function (d, i) {
    return "black"
  })
  .attr("stroke-width", function (d, i) {
    return 2;
  })

  // stroke-width="20"
  .attr("d", function (d) {
    return arc(d);
  });

arcs
  .append("text")
  .attr("transform", function (d) {
    d.innerRadius = 0;
    d.outerRadius = r;
    d.angle = (d.startAngle + d.endAngle) / 2;
    return (
      "rotate(" +
      ((d.angle * 180) / Math.PI - 88) +
      ")translate(" +
      (d.outerRadius - (window.innerWidth > 900 ? 60 : 20)) +
      ")"
    );
  })
  .attr("text-anchor", "end")
  .text(function (d, i) {
    return data[i].label;
    // return data[i].label+ String.fromCodePoint(data[i].emoji);
  });

// container.on("click", spin);
// $("body").keypress(spin);

function spin(d) {
  container.on("click", null);

  //  this is key to make spin stop exatly in a center of an arc !!
  var ps = 360 / data.length,
    //   1440 => 4* 360 4 tours
    pieslice = Math.round(1440 / data.length),
    // (Math.random() * 1440 + 360) => between 1 and 5 tours
    rng = Math.floor(Math.random() * 1440 + 360);

  rotation = Math.round(rng / ps) * ps;

  //   picked is the index of the picked data result
  picked = Math.round(data.length - (rotation % 360) / ps);
  picked = picked >= data.length ? picked % data.length : picked;
  //   console.log("picked is ======> ", picked);
  // let filtredDataIndex = data.filter(item => (item.value != 100 && item.value != 50))
  //  fonction recursive re spin until we get new result
  if (filtredDataIndex.indexOf(picked) !== -1) {
    console.log("111111111111 cbon ");
    d3.select(this).call(spin);
    // return;
  } else {
    console.log("222222222222 cbon ");
    rotation += 90 - Math.round(ps / 2);

    vis
      .transition()
      .duration(3000)
      .attrTween("transform", rotTween)
      .each("end", function () {
        d3.select("#number h1").text(data[picked].number);
        console.log('scrren');
        if (screen.width > 899) {
          document.getElementById('number').style.width = "45%"
        }
        document.getElementById('book__form__id').style.display = "none"
        oldrotation = rotation;
        if (data[picked].value != 0) {
          window.togglePause(false)
          const fireContainer = document.getElementById('fire-container-id')
          fireContainer.style.zIndex = 9999

          setTimeout(() => {
            window.togglePause(true)
            const fireContainer = document.getElementById('fire-container-id')
            fireContainer.style.zIndex = -1
          }, 7000);

        }

        //   spin while clicking on the surface
        //   container.on("click", spin);
      });
    console.log("spin method data[picked]", data[picked]);
    return data[picked]
  }


}

svg
  .append("g")
  .attr(
    "transform",
    "translate(" +
    (w + padding.left + padding.right) +
    "," +
    (h / 2 + padding.top) +
    ")"
  )
  .append("path")
  .attr("d", "M-" + r * 0.3 + ",0L0," + r * 0.05 + "L0,-" + r * 0.05 + "Z")
  .style({ fill: "black", opacity: "0.8" });

//   replace this with awesome button ?
// container
//   .append("circle")
//   .attr("cx", 0)
//   .attr("cy", 0)
//   .attr("r", 60)
//   .style({ fill: "white", cursor: "pointer" });

// container
//   .append("text")
//   .attr("x", 0)
//   .attr("y", 15)
//   .attr("text-anchor", "middle")
//   .text("SPIN")
//   .style({ "font-weight": "bold", "font-size": "30px" });

function rotTween(to) {
  // Returns an interpolator between the two arbitrary values a and b. 
  // The interpolator implementation is based on the type of the end value b, works with colors, date, string, nested values....
  var i = d3.interpolate(oldrotation % 360, rotation);
  return function (t) {
    return "rotate(" + i(t) + ")";
  };
}


function sendMailToTheWinner(formData = {
  fullName: "Jarraya",
  email: "mehdi.jarraya@esprit.tn"
}, prize = 20, userId) {
  console.log("sendMailToTheWinner", formData);
  // Set Form Values to Variables
  var subject = "Bon de réduction Nessrinou";
  var message = "Félicitation " + formData.fullName + "!" + " Vous avez gagné un bon de réduction de 20 dinars. Rendez vous à notre boutique Nessrinou ";
  var to = formData.email
  var commande = prize * 100 / 20

  var html = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
</head>
<body>
    <p>
    Félicitation ${formData.fullName} ! Vous avez gagné un bon de réduction de ${prize} dinars sur une commande de ${commande}.
        <br>
        Votre de code de réduction est ${userId}.
        <br>
        Rendez vous à notre boutique situé à 36 Avenue de Paris, Tunis 1000 
        <a href="https://www.google.com/maps/place/Nessrinou/@36.8048637,10.1835017,16z/data=!4m5!3m4!1s0x0:0x97e23380bc0ae2a0!8m2!3d36.8043335!4d10.1805054">
            (Coordonnées google maps)
        </a>.
        
        

        <br>
        Pour plus d'informations vous pouvez nous contacter sur notre page Facebook 
        <a href="https://www.facebook.com/NessRinou.shoes/">
            Nessrinou shoes
        </a> ou par téléphone +216 21137387.

    </p>
<br>
<a href="https://www.google.com/maps/place/Nessrinou/@36.8048637,10.1835017,16z/data=!4m5!3m4!1s0x0:0x97e23380bc0ae2a0!8m2!3d36.8043335!4d10.1805054">
<img  alt="Nessrinou" src="../img/nessrinoulocation-min.PNG" width="800" >
</a>
</body>
</html>`

  fetch('https://portfoliobackk.herokuapp.com/contact', {
    method: 'POST', // *GET, POST, PUT, DELETE, etc.
    headers: {
      'Content-Type': 'application/json'
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: JSON.stringify(
      {
        to,
        subject,
        message,
        html,

      }
    ) // body data type must match "Content-Type" header
  })
    .then(data => {
      console.log("sucess");
      console.log("200");
      console.log(data); // JSON data parsed by `data.json()` call
    }).catch(e =>
      console.log("fail", e));



}